import OneTrustCookieHelper from './code/Scripts/components/OneTrustCookieHelper.vue';

export default {
  components: {
    OneTrustCookieHelper,
  },
};
